'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bread = undefined;

var _Bread2 = require('./Bread');

var _Bread3 = _interopRequireDefault(_Bread2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Bread = _Bread3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Breads/default/Bread/index.js
// module id = 1624
// module chunks = 0